module.exports = require('./helpers/bundle-url').getBundleURL('fW6T3') + "logo.5ec3ca99.svg";